import React, { Component } from "react";
import PropTypes, { shape, node, func, bool, string } from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux/actions";
import { selectors } from "reducers/widgets";

import WidgetList from "pages/desktop/widgets/WidgetList";
import Button from "pages/_components/Button";
import MetrocorpWidgetItem from "pages/accounts/MetrocorpWidgetItem";
import * as i18nUtils from "util/i18n";
import Image from "pages/_components/Image";
import * as configUtils from "util/config";
import WidgetHeader from "./_components/WidgetHeader";
import InfoWidget from "./_components/InfoWidget";

const WIDGET_NAME = "metrocorp";

class Metrocorp extends Component {
    static propTypes = {
        closeButton: node,
        draggableItemProps: shape({}).isRequired,
        isEditable: bool,
        isFetching: bool.isRequired,
        dispatch: func.isRequired,
        errorMsg: string.isRequired,
        metrocorpLength: PropTypes.number.isRequired,
        isDesktop: bool,
        number: PropTypes.number,
        isFavorite: bool,
    };

    static defaultProps = {
        closeButton: null,
        isEditable: false,
        isDesktop: true,
        number: null,
        isFavorite: false,
    };

    render() {
        const {
            closeButton,
            errorMsg,
            metrocorpLength,
            number,
            draggableItemProps,
            dispatch,
            isEditable,
            isFetching,
            isDesktop,
            isFavorite,
        } = this.props;
        const uiAutomationProp = { "data-ui-automation": "widgetMetrocorp" };
        const confFavoriteAccountMetrocorp = configUtils.getBoolean(
            "frontend.favoriteAccount.Metrocorp.functionalities",
            false,
        );
        const showFavorite = isFavorite && confFavoriteAccountMetrocorp;

        return (
            <>
                <WidgetList
                    item={MetrocorpWidgetItem}
                    keyExtractor={(item) => item.idProduct}
                    name={WIDGET_NAME}
                    close={closeButton}>
                    {(list) => (
                        <div
                            role={isEditable ? "button" : "none"}
                            className={!isDesktop ? "widget metrocorp-widget" : "metrocorp-widget"}
                            {...uiAutomationProp}
                            {...draggableItemProps}
                            aria-roledescription={i18nUtils.get("desktop.widgets.message.roleDescription")}>
                            <WidgetHeader
                                title={
                                    <div className="d-flex align-items-center">
                                        {`${i18nUtils.get("metrocorp.title")}  | `}
                                        {showFavorite && !isFetching ? (
                                            <Image
                                                src="images/favorito.svg"
                                                className="d-flex mx-2 w-24px"
                                                wrapperClassName=""
                                            />
                                        ) : null}
                                        {!isFetching
                                            ? `${
                                                  number
                                                      ? i18nUtils.get("metrocorp.title.widget.secondPart", null, {
                                                            number: ` ${number}`,
                                                        })
                                                      : ""
                                              }`
                                            : null}
                                    </div>
                                }
                                action={
                                    <>
                                        {!errorMsg && metrocorpLength && !isEditable ? (
                                            <Button
                                                onClick={() => {
                                                    dispatch(push("/metrocorp"));
                                                }}
                                                bsStyle="outline"
                                                label="menu.seemore.label"
                                                type="button"
                                                image="images/arrow-right-blue.svg"
                                            />
                                        ) : (
                                            undefined
                                        )}
                                    </>
                                }
                            />
                            <div className="widget__content">
                                {!errorMsg && metrocorpLength && !isFetching ? (
                                    <InfoWidget text="metrocorp.title.widget.message" />
                                ) : (
                                    undefined
                                )}
                                {list}
                            </div>
                        </div>
                    )}
                </WidgetList>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        errorMsg,
        data: { client, metrocorp, isFavorite },
        isFetching,
    } = selectors.getWidget(state, WIDGET_NAME);

    return {
        isFetching,
        errorMsg,
        metrocorpLength: metrocorp.length,
        number: client?.cuentas?.ctaDep[0]?.numeroComitente,
        isFavorite,
    };
};

export default connect(mapStateToProps)(Metrocorp);
